import React, { useState, useEffect } from "react";
import axios from "axios";

// material-ui components
import { makeStyles } from "@material-ui/core/styles";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from 'components/Grid/GridItem.js';

// @material-ui/icons
import Close from "@material-ui/icons/Close";
import { infoColor } from "assets/jss/material-dashboard-pro-react.js";

// core components
import Button from "components/CustomButtons/Button.js";
import Table from 'components/Table/Table.js';

import modalStyle from "assets/jss/material-dashboard-pro-react/modalStyle.js";
import selectStyles from "assets/jss/material-dashboard-pro-react/customSelectStyle.js";

const customStyle = {
    right: { float: 'right' },
    modalTitle: { color: infoColor[0], fontWeight: 'bold' },
    modalHeader: { borderBottom: '2px solid ' + infoColor[0] },
    select: { minWidth: '200px' }
}
const defaultStyles = makeStyles(selectStyles);
const useStyles = makeStyles(modalStyle);
const customStyles = makeStyles(customStyle);

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

export default function ScenarioCopyPopup(props) {
    const { factoryId, requestId, modal, onClose } = props;
    const classes = { ...useStyles(), ...defaultStyles(), ...customStyles() };

    const [solutionList, setSolutionList] = useState({ solution: [] });

    useEffect(() => {
        axios.get('aps/list/solution').then(response => {
            setSolutionList({...solutionList, solution: response.data.data.filter(item => item.factory_id === factoryId && item.request_id === requestId)});
        });
    }, [requestId]);

    const setModal = function (modal) {
        onClose(modal);
    };

    return (
        <Dialog classes={{ root: classes.center, paper: classes.modal }}
            open={modal} transition={Transition} keepMounted
            onClose={() => setModal(false)}
            aria-labelledby="modal-slide-title" aria-describedby="modal-slide-description" >
            <DialogTitle id="classic-modal-slide-title" disableTypography className={classes.modalHeader}>
                <Button justIcon className={classes.modalCloseButton} key="close"
                    aria-label="Close" color="transparent" onClick={() => setModal(false)}>
                    <Close className={classes.modalClose} />
                </Button>
                <h4 className={classes.modalTitle}>Solution : {requestId}</h4>
            </DialogTitle>
            <DialogContent id="modal-slide-description" className={classes.modalBody}>
                <GridContainer justify="center">
                    <GridItem>
                        <Table striped
                                tableHeaderColor="primary"
                                tableHead={["설비 할당", "제품명", "공정명", "공정순서", "시작 시간", "종료 시간", "생산량", "할당ID"]}
                                tableCols={["machine_id", "product_id", "oper_id", "oper_seq", "start_time", "end_time", "qty", "job_id"]}
                                tableData={solutionList.solution}/>
                    </GridItem>
                </GridContainer>
            </DialogContent>
        </Dialog>
    );
}